import React, { PureComponent } from 'react'

import './PseudoSelect.scss'

interface PseudoSelectProps {
  onClick: () => void,
  id?: string,
  children: string
}

class PseudoSelect extends PureComponent<PseudoSelectProps> {
  render() {
    const {
      children,
      onClick,
      id
    } = this.props

    return (
      <div
        id={id}
        className="pseudo-select"
        onClick={onClick}
      >
        {children}
      </div>
    )
  }
}

export default PseudoSelect
